// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useExerciseSubmission } from '@hooks/mutations/ledger/useSubmission';
import { BurnRequest } from '@daml.js/utility-registry-v0/lib/Utility/Registry/V0/Holding/Burn';
import { ERR_CAN_BURN, SUC_CAN_BURN } from '../../../../utils/strings';

export const useCancelBurnRequest = () => {
  const { submit } = useExerciseSubmission(
    BurnRequest.BurnRequest_Cancel,
    SUC_CAN_BURN,
    ERR_CAN_BURN,
  );
  return submit;
};
